import { useEffect, useState } from "react"

import { Alert, App, Flex, Layout, Modal, Space, Spin, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import ReactPlayer from "react-player"
import { connect } from "react-redux"
import { useParams } from "react-router"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

import ButtonComponent from "../Components/Button"
import ConnectMaverick from "../Components/Forms/ConnectMaverick"
import ConnectPaymentProcessorForm from "../Components/Forms/ConnectPaymentProcessorForm"
import LoginHeader from "../Components/LoginHeader"
import LogOutText from "../Components/LogOutText"
import PrivacyPolicy from "../Components/PrivacyPolicy"
import StepTitle from "../Components/StepTitle/StepTitle"
import Tour from "../Components/Tour"
import {
  getMaverickTooltipContent,
  stepsTourConnectPaymentProcessor
} from "../Components/Tour/stepsTourConnectPaymentProcessot"
import IntegrationCard from "../Containers/IntegrationsPage/components/Card"
import Icon from "../Icon"
import { modalConfig } from "../theme"
import { highAccessRoles } from "../Utils/permission"
import utils, {
  createAccountStepPath,
  handleViewTutorial,
  manageEnrollmentStepPath,
  onboardingStepPath,
  paymentProcessorDescription,
  paymentProcessorMap
} from "../Utils/utils"
import AdyenConnectionSuccessModal from "./IntegrationsPage/Adyen/SuccessModal/AdyenConnectionSuccessModal"
import ConnectNextcommerce from "./IntegrationsPage/Nextcommerce/ConnectNextcommerce"
import useNextcommerceDisconnect from "./IntegrationsPage/Nextcommerce/hooks/useNextcommerveDisconnect"
import { changeNextCreateAccountStep, userSetProp } from "./User/redux/user.actions"
import { userActions } from "./User/redux/user.slice"
import {
  changeOnboardingStep,
  connectPaymentProcessor,
  disconnectPaymentProcessor,
  getPaymentProcessors
} from "./User/redux/user.thunks"
import { updateCompletedStep } from "./User/services"

const { Title, Text } = Typography

function OnboardingPaymentConnectPage(props) {
  const {
    auth: { fetching, userInfo, isAdmin },
    isOneProcessorConnected,
    userFetching,
    businessAccountFetching,
    saveResult,
    businessAccount,
    paymentProcessors,
    nextCreateAccountStep,
    isMobile,
    step,
    maxStep,
    businessAccounts
  } = props

  const { enrollmentId } = useParams()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { notification, modal } = App.useApp()

  const [openTour, setOpenTour] = useState(false)

  // show modal
  const [visible, setVisible] = useState(false)
  // video or connectForm
  const [modalType, setModalType] = useState("")

  //const [selectedPayment, setSelectedPayment] = useState([])
  const [connectPayment, setConnectPayment] = useState(null)
  const [showAdyenSuccessModal, setShowAdyenSuccessModal] = useState(false)

  const [customConnectServiceName, setCustomConnectServiceName] = useState(null)

  const hasHighAccessRole = businessAccounts?.some(({ role }) =>
    highAccessRoles?.includes(role?.id)
  )
  const currentAdminBusinessAccountId = searchParams.get("business_account_id") || enrollmentId
  let businessId = isAdmin
    ? currentAdminBusinessAccountId
    : nextCreateAccountStep
      ? businessAccount?.id
      : userInfo?.["current_business_account_id"]
  let selectedPayment = paymentProcessors
    ?.filter((pp) => pp?.["is_connected"])
    ?.map((pp) => pp?.["service_name"])
  let selectedNotManual = selectedPayment.length && !selectedPayment?.includes("manual_refunds")

  const notificationConfig = {
    closeIcon: <Text>{t("Dismiss")}</Text>,
    style: { minWidth: "max-content" }
  }

  const handleCloseModal = () => {
    setVisible(false)
    setModalType("")
    if (saveResult?.["connect_error"]) props.userSaveResultReset()
  }

  useEffect(() => {
    if (userInfo && businessId) {
      props.getPaymentProcessors({
        merchant_id: businessId,
        return_url: process.env.REACT_APP_BASE_URI + location.pathname
      })
    }
    document.title = "Payment processor connect - Chargeback"
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [fetching, businessId])

  useEffect(() => {
    if (!connectPayment) {
      if (userInfo?.["new_onboarding_finished"]) {
        if (enrollmentId) {
        } else {
          props.changeNextCreateAccountStep(2)
        }
      } else {
        if (userInfo?.next_step - 2 > step) {
          props.changeOnboardingStep({ next_step: step + 2 })
          updateCompletedStep({ step: step - 1, business_account_id: businessId })
        }
      }
    }
  }, [connectPayment])

  useEffect(() => {
    if ((saveResult === "connected" || saveResult === "disconnected") && connectPayment) {
      let namePayment =
        paymentProcessorMap?.[connectPayment.service_name] ||
        utils.toUpperLatter(connectPayment.service_name)
      let message = null
      let description = null
      if (saveResult === "connected") {
        if (connectPayment.service_name === "manual_refunds") {
          message = t("Manual Refunds Selected")
          description = t("Manual Refunds was selected successfully")
        } else {
          message = t("Payment processor connected")
          description = t("_namePayment_ was connected successfully.", { namePayment })
        }
      } else if (saveResult === "disconnected") {
        if (connectPayment.service_name === "manual_refunds") {
          message = t("Manual Refunds Deselected")
          description = t("Manual Refunds was deselected successfully")
        } else {
          message = t("Payment processor disconnected")
          description = t("_namePayment_ was disconnected successfully.", { namePayment })
        }

        if (
          !isOneProcessorConnected &&
          connectPayment.service_name !== "manual_refunds" &&
          enrollmentId
        ) {
          props.getPaymentProcessors({
            merchant_id: businessId,
            return_url: process.env.REACT_APP_BASE_URI + location.pathname
          })
        }
      }
      if (connectPayment?.service_name === "adyen" && saveResult === "connected") {
        setShowAdyenSuccessModal(true)
      } else {
        notification.success({
          message,
          description,
          ...notificationConfig
        })
      }
      handleCloseModal()
      props.userSaveResultReset()
    }
  }, [saveResult, isOneProcessorConnected])

  function handleSubmit() {
    if (selectedPayment?.length) {
      if (nextCreateAccountStep) {
        updateCompletedStep({ step, business_account_id: businessId })
        props.changeNextCreateAccountStep(3)
        navigate(createAccountStepPath[step + 1])
      } else if (enrollmentId) {
        props.setNextManageEnrollmentStep(2)
        navigate(`${manageEnrollmentStepPath(enrollmentId, isAdmin)[2]}${location.search}`, {
          replace: true
        })
      } else {
        if (userInfo?.next_step - 2 === step) props.changeOnboardingStep({ next_step: 5 })
        updateCompletedStep({ step, business_account_id: businessId })
        navigate(onboardingStepPath[step + 2 + 1])
      }
    } else {
      modal.warning({
        ...modalConfig("info"),
        okButtonProps: { size: "large", style: { width: "auto" } },
        centered: !isMobile,
        //transitionName: '',

        title: t("Connect a payment processor or enable manual refunds"),
        content: t(
          "To activate your Chargeback account, either connect at least one payment processor or select Manual Refunds as your preferred option."
        ),
        okText: t("Confirm")
      })
    }
  }

  const { disconnectNext } = useNextcommerceDisconnect()

  const disconnectPayment = (payment) => {
    modal.confirm({
      ...modalConfig("exclamation"),
      centered: !isMobile,
      //transitionName: '',

      title: t("Disconnect payment processor"),
      content: t("Are you sure you want to disconnect your payment processor?"),

      cancelText: t("Cancel"),
      okText: t("Disconnect"),
      onOk() {
        if (payment.service_name === "next") {
          disconnectNext(businessId)
          return
        }
        props.disconnectPaymentProcessor({
          payment_processor_id: payment.id,
          service_name: payment.service_name
        })
      },
      onCancel() {
        console.log("Cancel")
      }
    })
  }

  const handleConnectPaymentWithForm = (data) => {
    if (!connectPayment) return
    props.connectPaymentProcessor({
      service_name: connectPayment.service_name,
      merchant_id: connectPayment.merchant_id,
      ...data
    })
  }

  const handleClick = (payment) => {
    if (payment.is_connected) {
      //if (enrollmentId) return
      setConnectPayment(payment)
      disconnectPayment(payment)
    } else if (payment?.service_name === "next") {
      setCustomConnectServiceName(payment.service_name)
    } else {
      if (!payment.link && payment?.["list_of_required_fields_for_tokens"].length) {
        setConnectPayment(payment)
        setOpenTour(true)
        //setModalType('connectForm')
        //setVisible(true)
      } else {
        if (payment.service_name === "manual_refunds") {
          setConnectPayment(payment)
          props.connectPaymentProcessor({
            service_name: payment.service_name,
            payment_processor_id: payment.id
          })
        } else {
          if (payment.link) utils.goLink(payment.link)
          //handleConnectPayment(payment.service_name)
        }
      }
    }
  }

  const handleCloseTour = () => {
    setOpenTour(false)
    setModalType("connectForm")
    setVisible(true)
  }

  const handleOpenTour = () => {
    setOpenTour(true)
    setModalType(null)
    setVisible(false)
  }

  const TutorialButton = ({ serviceName }) => {
    const isAdyen = serviceName === "adyen"

    return (
      <ButtonComponent
        type="text"
        size="large"
        className="flex center"
        style={{ marginRight: "auto" }}
        icon={isAdyen ? null : <Icon type="arrow_left" />}
        onClick={isAdyen ? handleViewTutorial : handleOpenTour}
      >
        {t("View tutorial")}
      </ButtonComponent>
    )
  }

  const renderConnectFormComponent = (connectPayment, businessId, handlers) => {
    const commonProps = {
      fields: connectPayment?.["list_of_required_fields_for_tokens"]?.filter(
        (el) => el !== "merchant_id"
      ),
      onClose: handlers.handleCloseModal,
      service_name: connectPayment?.service_name,
      disabled: handlers.businessAccountFetching,
      error: handlers.saveResult?.["connect_error"],
      extraBtn: (
        <TutorialButton
          serviceName={connectPayment?.service_name}
          onOpenTour={handlers.handleOpenTour}
          onViewTutorial={handleViewTutorial}
        />
      )
    }

    if (connectPayment?.service_name === "maverick") {
      return <ConnectMaverick {...commonProps} merchant_id={businessId} isMobile={isMobile} />
    }

    return (
      <ConnectPaymentProcessorForm
        {...commonProps}
        onSubmit={handlers.handleConnectPaymentWithForm}
      />
    )
  }

  const modalBlocks = {
    connectForm: {
      classNames: {
        content: cls("clear-bg full-width-header", {
          "bg-center": modalType === "success",
          "payment-connect": modalType === "connectForm",
          recurly: connectPayment?.["service_name"] === "recurly"
        }),
        header: cls({
          "payment-connect": modalType === "connectForm",
          [`${connectPayment?.["service_name"]}`]: modalType === "connectForm"
        })
      },
      title: (
        <Space direction="vertical">
          <Text className="payment-connect-title">
            {t("_namePayment_ integration", {
              namePayment: paymentProcessorMap[connectPayment?.["service_name"]]
            })}
          </Text>
          <Text className="payment-connect-sub_title">
            {t(
              paymentProcessorDescription[connectPayment?.["service_name"]] ??
                "Connect your _namePayment_ account to fully automate your _namePayment_ disputes.",
              { namePayment: paymentProcessorMap[connectPayment?.["service_name"]] }
            )}
          </Text>
        </Space>
      ),
      component: renderConnectFormComponent(connectPayment, businessId, {
        handleCloseModal,
        businessAccountFetching,
        saveResult,
        handleConnectPaymentWithForm,
        handleOpenTour
      })
    },
    video: {
      classNames: { wrapper: "video-modal", content: "clear-bg" },
      title: null,
      component: (
        <ReactPlayer
          controls={true}
          width={"100%"}
          height={"100%"}
          playing={true}
          url={"https://www.youtube.com/watch?v=OftbjjbL0tc"}
        />
      )
    }
  }

  return (
    <Layout>
      <Spin size="large" spinning={fetching || businessAccountFetching || userFetching}>
        <div className="login-row">
          <LoginHeader />
          <div className="login-content">
            <div className="content-main sign-up">
              <StepTitle step={step} maxStep={maxStep} />

              <Flex
                vertical
                align={"center"}
                style={{
                  margin: "0 0 auto",
                  width: "100%",
                  maxWidth: 1040,
                  padding: !isMobile ? "0 24px" : "0 16px"
                }}
              >
                <Flex
                  gap={16}
                  justify="space-between"
                  align="center"
                  style={{ width: "100%" }}
                  wrap="wrap"
                >
                  <Space direction="vertical" size={0}>
                    <Title level={5} style={{ width: 320, textAlign: "left" }}>
                      {t("Payment processor")}
                    </Title>
                    <Text type={"secondary"} style={{ width: 320 }}>
                      {t("What payment processor does _businessName_ use?", {
                        businessName: businessAccount?.name
                      })}
                    </Text>
                  </Space>

                  <Flex gap={12}>
                    <ButtonComponent
                      className={"flex center small-space"}
                      block
                      /*onClick={() => {
                                       setModalType('video')
                                       setVisible(true)
                                     }}*/
                      onClick={() =>
                        utils.goLink("https://www.youtube.com/@chargebackio/videos", "_blank")
                      }
                      style={{ padding: "4px 20px" }}
                    >
                      {t("Watch tutorial")}
                      <Icon role="icon" type="youtube" />
                    </ButtonComponent>

                    <ButtonComponent
                      className={"flex center small-space"}
                      block
                      style={{ padding: "4px 20px" }}
                      onClick={() =>
                        utils.goLink(
                          "https://help.chargeback.io/en/collections/16516793-setting-up-integrations",
                          "_blank"
                        )
                      }
                    >
                      {t("Learn more")}
                      <Icon role="icon" type="edit" style={{ fontSize: 20, color: "#7A7A83" }} />
                    </ButtonComponent>
                  </Flex>
                </Flex>

                <Alert
                  className="primary"
                  icon={<Icon type="sparkles_soft" />}
                  showIcon
                  message={<Text strong>{t("Important notice")}</Text>}
                  description={
                    <Text>
                      {t(
                        enrollmentId
                          ? "Please be aware that connecting or disconnecting an integration will affect the entire business account, not just the selected enrollment."
                          : "Connect your payment processor for automatic chargeback prevention. If your payment processor isn't visible, select manual refunds instead."
                      )}
                    </Text>
                  }
                  style={{ margin: "32px 0 24px", width: "100%" }}
                />

                <Flex
                  gap={16}
                  wrap="wrap"
                  justify="center"
                  align="stretch"
                  style={{ margin: "0 0 24px" }}
                >
                  {paymentProcessors
                    ?.map((el) => ({
                      ...el,
                      is_connected: el.is_connected,
                      title: el.title || paymentProcessorMap?.[el.service_name] || el.service_name,
                      isDisabled:
                        el.isDisabled || (el.service_name === "manual_refunds" && selectedNotManual)
                      //|| (enrollmentId && el.is_connected)
                      //disabledStatus: (enrollmentId && el.is_connected) ? 'Connected' : null,
                    }))
                    .map((payment) => {
                      return (
                        <IntegrationCard
                          key={payment.id}
                          //onlyConnect={enrollmentId}
                          data={payment}
                          style={{ width: 320 }}
                          onClick={handleClick}
                          disabled={
                            !isAdmin &&
                            !hasHighAccessRole &&
                            location.pathname.includes("/configure/enrollment")
                          }
                          tooltip={getMaverickTooltipContent}
                        />
                      )
                    })}
                </Flex>

                <ButtonComponent
                  type="primary"
                  size="large"
                  loading={userFetching}
                  onClick={handleSubmit}
                  className={"flex center"}
                  style={{ width: 320 }}
                >
                  {t("Continue")}
                </ButtonComponent>
              </Flex>

              <PrivacyPolicy />
              {!userInfo?.new_onboarding_finished && <LogOutText />}
            </div>
          </div>
        </div>
      </Spin>

      <Tour
        open={openTour}
        steps={stepsTourConnectPaymentProcessor()[connectPayment?.service_name]}
        onClose={handleCloseTour}
        key={connectPayment?.service_name}
      />

      <Modal
        {...(isMobile ? { transitionName: "" } : null)}
        open={visible}
        centered={!isMobile}
        width={442}
        title={modalBlocks[modalType]?.title}
        footer={null}
        closable="true"
        closeIcon={<Icon type="close_modal" />}
        onCancel={handleCloseModal}
        destroyOnClose
        classNames={modalBlocks[modalType]?.classNames}
      >
        <Spin size="large" spinning={fetching} wrapperClassName="visible">
          {modalBlocks[modalType]?.component}
        </Spin>
      </Modal>
      <AdyenConnectionSuccessModal
        opened={showAdyenSuccessModal}
        close={() => setShowAdyenSuccessModal(false)}
      />
      {customConnectServiceName === "next" && (
        <ConnectNextcommerce
          onFinish={() => setCustomConnectServiceName(null)}
          isMobile={isMobile}
        />
      )}
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  isMobile: state.nav.isMobile,

  userFetching: state.user.fetching,
  businessAccountFetching: state.user.businessAccountFetching,
  paymentProcessors: state.user.paymentProcessors,
  businessAccount: state.user.businessAccount,

  nextCreateAccountStep: state.user.nextCreateAccountStep,
  saveResult: state.user.saveResult,

  isOneProcessorConnected: state.user.isOneProcessorConnected,
  businessAccounts: state.user.businessAccountsWithRole
})

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  //getBusinessAccounts: () => dispatch(getBusinessAccounts()),
  changeOnboardingStep: (data) => dispatch(changeOnboardingStep(data)),
  changeNextCreateAccountStep: (nextStep) => dispatch(changeNextCreateAccountStep(nextStep)),

  getPaymentProcessors: (data) => dispatch(getPaymentProcessors(data)),
  connectPaymentProcessor: (data) => dispatch(connectPaymentProcessor(data)),
  disconnectPaymentProcessor: (data) => dispatch(disconnectPaymentProcessor(data)),
  userSaveResultReset: () => dispatch(userActions.userSaveResultReset()),
  setNextManageEnrollmentStep: (step) =>
    dispatch(userSetProp({ key: "nextManageEnrollmentStep", value: step }))
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingPaymentConnectPage)
